import * as _ from 'lodash';
import { IContact, IOpsSchedule } from '@nkr/models/index';

interface IProps {
    index: number,
    count: number,
    data: IOpsSchedule,
    staffList: IContact[]
}

const PreviewRow = (props: IProps) => {
    const staffItem = props.staffList.find(x => x.id == props.data.employeeId);

    if (staffItem == null)
        return null;

    const { backgroundColor, color, days } = props.data;

    const sortedDays = _.sortBy(days, x => x.displayOrder);

    return (
        <tr style={{ backgroundColor, color }}>
            {props.index == 0 && (
                <td rowSpan={props.count} style={{ color: '#333', backgroundColor: 'white' }}>Office Hours</td>
            )}
            <td>{staffItem.firstName}</td>
            {sortedDays.map(day =>
                <>
                    <td>{day.startTime}</td>
                    <td>{day.endTime}</td>
                </>
            )}
        </tr>
    );
}

export default PreviewRow;